module.exports = "<loading message=\"Loading...\"></loading>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/goto/goto.component.html
// module id = ./client/app/goto/goto.component.html
// module chunks = main